import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IFeeSchedule } from './feeSchedule'
import { IEntityGroup } from './entityGroup'
import { ODataService } from 'common-services'

export interface IEntityGroupFeeSchedule extends IModelBase {
  EntityGroupId: number
  EntityGroup: IEntityGroup
  FeeScheduleId: number
  FeeSchedule: IFeeSchedule
  Start: Date
  End: Date
}

@Injectable()
export class EntityGroupFeeScheduleODataService extends ODataService<IEntityGroupFeeSchedule> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'EntityGroupFeeSchedules'
  }
}
